import React from 'react';

const AboutPage = () => (
    <div className='content'>


        <h1>About Us</h1>


        <p>Little Nest Preschool is a cozy, nurturing half-day program for
            preschoolers aged 2&frac12; - 5.  We have a Montessori-inspired
            environment. Our objective is to provide a balanced curriculum where
            children learn by doing and exploring and where the environment and
            experiences are in tune with the characteristics of the child.</p>

        <h2>Program Goals</h2>

        <ul>

            <li>To create a safe, supportive, and stimulating environment that
                encourages the social, emotional, physical, and mental development
                of young children through creative play.</li>

            <li>To nurture each child's sense of accomplishment and personal
                growth.</li>

            <li>To encourage families to share their unique talents, interests,
                and experiences in ways that enhance their child's class as well as
                the larger preschool community.</li>

            <li>To develop and strengthen skills in group process, mediation,
                and leadership.</li>

            <li>To foster a sense of community, support, and belonging for all
                those involved in the preschool.</li>

        </ul>

        {/* <h2 className='teacher'>Anna Coble, Founder and Director</h2>
        <table>
            <tbody>
            <tr>
                <td className='teacher'>
                    <img className="teacher" src="/images/Anna.jpg"/>
                </td>
                <td className="description">

                    <p>Anna is a certified Montessori teacher for ages 2&frac12; - 5.  She
                        completed her training in 2001 with the Montessori College for Early
                        Education.  Anna has worked with preschoolers in a variety of settings
                        over the last 17 years.  She provides a stimulating environment where
                        children can make their own discoveries.  She loves working with young
                        children and brings her passion for art and nature into the classroom.
                        Anna is the proud mom of two wonderful children!</p>

                    <p>2019-2020 is Anna's 10th year running Little Nest.</p>
                </td>
            </tr>
            </tbody>
        </table> */}
        <h2 className='teacher'>Tracy Koehler, Director</h2>

        <table>
            <tbody>
            <tr>
                <td className='teacher'>
                    <img className="teacher" src="/images/Tracy.jpg"/>
                </td>
                <td className="description">

                    <p>Tracy received a Bachelor's Degree in Family Studies and Consumer
                        Sciences with an emphasis on Child Development.  She has worked with
                        children ages 3-5 for 10 years.  Tracy believes that the process of
                        art is very important, how the children make their artwork and add new
                        ideas of their own to it.  Messy projects are her favorite!  She loves
                        to teach children about the world around them through hands on
                        activities.  Tracy enjoys drawing, photography, hiking, and being
                        outdoors.  She is the mom of 2 fun loving active boys.
                    </p>

                    <p>Tracy joined Little Nest in the Winter of 2014-15.</p>
                </td>
            </tr>
            </tbody>
        </table>

        <h2 className='teacher'>Kelly McIntyre, Co-Teacher</h2>

        <table>
            <tbody>
            <tr>
                <td className='teacher'>
                    <img className="teacher" src="/images/Kelly.jpg"/>
                </td>
                <td className="description">

                    <p>
                        Kelly has been working with children for over 15 years. While earning
                        a BA in the Humanities at Western Washington University, she began
                        working with young children in a classroom setting, and hasn't looked
                        back. She has taught summer camps, kindergarten-enrichment,
                        Montessori, and preschool and nannied and worked in a co-op setting
                        with both of her children. Kelly started helping with at Little Nest
                        when her son was attending and is thrilled to be more involved now
                        that her daughter is a student there. She loves the child-centered,
                        nurturing environment and the wonderful community of teachers and
                        parents.
                    </p>

                    <p>Kelly has been teaching at Little Nest for seven years.</p>
                </td>
            </tr>
            </tbody>
        </table>


        <h2 className='teacher'>Yuko Ueda, Co-Teacher</h2>

        <table>
            <tbody>
            <tr>
                <td className='teacher'>
                    <img className="teacher" src="/images/yuko.jpg"/>
                </td>
                <td className="description">
                    <p>
                        Yuko graduated from Tsuda University, Tokyo, Japan with a Bachelor's
                        Degree in English Language and Literature. During that time she completed
                        a secondary course of study in Teaching Japanese as a second language.
                        She has a teaching license in Japan for teaching English.

                        She has been involved in the early childhood education environment for
                        6 years since moving to the greater Seattle area. Both of her children
                        went through a Japanese Co-op Preschool where she took turns with other
                        mothers teaching language and culture. Currently she teaches at a Japanese
                        language preschool and has been volunteering at her children's school as a
                        parental helper. She loves working with children.</p>

                    <p>Yuko joined the LittleNest team in 2018</p>
                </td>
            </tr>
            </tbody>
        </table>
        <h2 className='teacher'>Melanie Burch, Guest Teacher / Substitute</h2>
        <table>
            <tbody>
            <tr>
                <td className='teacher'>
                    <img width="200" src="/images/melanie.png"/>
                </td>
                <td className='description'>
                    <p>Melanie (Mel) Burch was a Preschool Teacher for 8 years at Monkey
                        Business Preschool in Greenwood.  She taught Music Together for
                        2 years, taught classroom music classes to her sons' K-1st grades
                        when they were younger (Her boys are now 10, 14, and 17).  She
                        was a nanny before she had children of her own, and now volunteers
                        as a NICU baby cuddler in Edmonds.  She is thrilled to be joining
                        the Little Nest Community.
                    </p>
                </td>
            </tr>
            </tbody>
        </table>

    </div>
);

export default AboutPage;



// WEBPACK FOOTER //
// ./src/components/AboutPage.js